import React, { Component } from "react";
import logo from "../images/confia-logo.svg";
import Footer from "../components/Footer/Footer";
import CompanyLogo from "../components/CompanyLogo/CompanyLogo.";
import PropTypes from "prop-types";

export class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = { logoSrc: logo };
  }
  async componentDidMount() {
    if (this.props.logo) {
      await this.setState({ logoSrc: this.props.logo });
    }
  }
  render() {
    return (
      <span>
        <div className="container h-100 w-100" style={{ backgroundImage: "#1e1e1e", maxWidth: "100%" }}>
          <div className="row h-100 align-items-center ">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 h-100 align-self-center position-relative">
              <div className="mx-auto d-block position-absolute top-50 start-50 translate-middle">
                <CompanyLogo logo={this.props.logo} />
                {/* <img alt="Confia" style={{ height: "100px" }} src={logo} className="img-fluid mx-auto d-block position-absolute top-50 start-50 translate-middle" /> */}
              </div>
              <main className="position-relative" style={{ top: "50%" }}>
                <div className="loading-bar-container ">
                  <div className="loading-bar" />
                </div>
                <h5 className="position-absolute start-50 translate-middle mt-4">Carregando</h5>
              </main>
              <div className="position-relative" style={{ top: "70%", textAlign: "center" }}></div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

Loading.propTypes = {
  footerMessage: PropTypes.string.isRequired,
};

export default Loading;
